import Agent from '../api/Agent'
import { EnquiryGovCMSSearchRequest } from '../models/Enquiry'
import { CancelTokenSource } from 'axios'

class GovCMSService {
  getGovCMSPages = async (request: EnquiryGovCMSSearchRequest) => {
    return Agent.GovCMS.getGovCMSPages(request)
  }

  getGovCMSNewsAlerts = async (source?: CancelTokenSource) => {
    return Agent.GovCMS.getGovCMSNewsAlerts(source)
  }
}

export default new GovCMSService()
